import { useEffect, useMemo } from 'react';
import { LoadingScreen } from 'components/Loaders/LoadingScreen';
import { useAuth } from 'contexts/authContext';
import { DashboardScreen } from 'pages/dashboard';
import { LoginScreen } from 'pages/loginScreen';
import { Acceptances } from 'pages/loginScreen/Acceptances';
import { useTranslation } from 'react-i18next';
import { RouteObject, useRoutes } from 'react-router-dom';
import { MainLayout } from 'root/MainLayout';
import { getDefaultNavOptions } from 'root/Navbar/navOptions';
import { reactPaths } from 'root/pathnames';
import { RequireAuth, RequireUnAuth } from './AuthRoutes';
import { clientRoutes, getDefaultRoutes } from './routes';

export function App() {
  const { user, loading, checkAuth } = useAuth();
  const { i18n } = useTranslation();

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const defaultRoutes = useMemo(() => {
    const [defaultNavItems] = getDefaultNavOptions(i18n);
    return getDefaultRoutes(defaultNavItems);
  }, [i18n]);

  const routes: RouteObject[] = useMemo(() => {
    const modulesRoutes = !user
      ? []
      : user?.clientPanelUser
      ? clientRoutes
      : defaultRoutes;

    return [
      {
        path: reactPaths.login,
        element: (
          <RequireUnAuth>
            <LoginScreen />
          </RequireUnAuth>
        ),
      },
      {
        path: reactPaths.acceptances,
        element: (
          <RequireUnAuth>
            <Acceptances />
          </RequireUnAuth>
        ),
      },
      {
        path: reactPaths.home,
        element: (
          <RequireAuth>
            <MainLayout />
          </RequireAuth>
        ),
        children: [
          {
            index: true,
            element: <DashboardScreen />,
          },
          ...modulesRoutes,
          {
            path: '*',
            element: <h2>Page does not exist.</h2>,
          },
        ],
      },
    ];
  }, [user, defaultRoutes]);

  const element = useRoutes(routes);

  if (loading) {
    return <LoadingScreen />;
  }

  return element;
}
